export default defineNuxtRouteMiddleware((to) => {
  const userStore = useUserStore();
  const localePath = useLocalePath();

  const user = userStore.getUser;

  // Avoid redirect until user is loaded
  if (!user) return;

  const allowedPaths = [
    localePath("/verification"),
    localePath("/document-verification"),
  ];

  const isAllowed = allowedPaths.some(
    (path) => to.path.startsWith(path) // handles query params too
  );

  if (user.ask_for_verification === 1 && !isAllowed) {
    return navigateTo(localePath("/verification"), { replace: true });
  }
});
